import {Locales} from '@netx/core-next/locales/utils/Locales';
import {i18n} from '@netx/core-next/locales/i18n-instance';

import {PERMISSION_MATRIX_NAMES} from '../constants';

// Names for the six bits on a permissionsMatrix, in the order they appear on asset & category models:
export const matrixNames = PERMISSION_MATRIX_NAMES;

export const AssetPermissionTypeLabel = Locales((i18n) => ({
	ALL: i18n('i18n.acl-ALL'),
	READ: i18n('i18n.acl-READ'),
	DOWNLOAD: i18n('i18n.acl-DOWNLOAD'),
	ADD: i18n('i18n.acl-ADD'),
	MODIFY: i18n('i18n.acl-MODIFY'),
	DELETE: i18n('i18n.acl-DELETE'),
}));

// These *Types data structures are optimized for creating OPTION lists in forms.  Their order must be preserved.
export const permissionTypes = [
	{
		key: 'ALL',
		label: i18n.t('i18n.acl-ALL'),
		value: 9,
	},
	{
		key: 'READ',
		label: i18n.t('i18n.acl-READ'),
		value: 1,
	},
	{
		key: 'DOWNLOAD',
		label: i18n.t('i18n.acl-DOWNLOAD'),
		value: 2,
	},
	{
		key: 'ADD',
		label: i18n.t('i18n.acl-ADD'),
		value: 3,
	},
	{
		key: 'MODIFY',
		label: i18n.t('i18n.acl-MODIFY'),
		value: 5,
	},
	{
		key: 'DELETE',
		label: i18n.t('i18n.acl-DELETE'),
		value: 7,
	},
];

export const AssetPermissionPrincipalLabel = Locales((i18n) => ({
	ANY: i18n('i18n.acl-ANY'),
	GROUP: i18n('i18n.acl-GROUP'),
	USER: i18n('i18n.acl-USER'),
}));

export const principalTypes = [
	{
		key: 'ANY',
		label: i18n.t('i18n.acl-ANY'),
		value: 0,
	},
	{
		key: 'GROUP',
		label: i18n.t('i18n.acl-GROUP'),
		value: 1,
	},
	{
		key: 'USER',
		label: i18n.t('i18n.acl-USER'),
		value: 2,
	},
];

export const AssetPermissionTargetLabel = Locales((i18n) => ({
	category: i18n('i18n.category'),
	asset: i18n('i18n.asset'),
}));

export const targetTypes = [
	{
		key: 'category',
		label: i18n.t('i18n.category'),
		value: 0,
	},
	{
		key: 'asset',
		label: i18n.t('i18n.asset'),
		value: 1,
	},
];

export const AssetPermissionPermitTypeLabel = Locales((i18n) => ({
	PERMIT: i18n('i18n.acl-PERMIT'),
	DENY: i18n('i18n.acl-DENY'),
}));

export const typeTypes = [
	{
		key: 'PERMIT',
		label: i18n.t('i18n.acl-PERMIT'),
		value: 1,
	},
	{
		key: 'DENY',
		label: i18n.t('i18n.acl-DENY'),
		value: 0,
	},
];

const properties = {
	matrixNames,
	permissionIds: {},
	permissionLabels: {},
	permissionTypes,
	principalIds: {},
	principalLabels: {},
	principalTypes,
	targetIds: {},
	targetLabels: {},
	targetTypes,
	typeIds: {},
	typeLabels: {},
	typeTypes,
};

// Parse the *Types data structures into *Ids data structures optimized for looking up ID by label or vise versa:
(['permission', 'principal', 'target', 'type'] as const).forEach((thing) => {
	const obj: Record<string, number> = {};
	const obj2: Record<number, string> = {};
	Object.entries(properties[`${thing}Types`]).forEach(([, entry]) => {
		obj[entry.key] = entry.value;
		obj2[entry.value] = entry.label;
	});
	properties[`${thing}Ids`] = obj;
	properties[`${thing}Labels`] = obj2;
});

export const targetIds = properties.targetIds;
export const targetLabels = properties.targetLabels;
export const permissionIds = properties.permissionIds;
export const permissionLabels = properties.permissionLabels;
export const principalIds = properties.principalIds;
export const principalLabels = properties.principalLabels;
export const typeIds = properties.typeIds;
export const typeLabels = properties.typeLabels;

export default properties;
